import { render, staticRenderFns } from "./vip-board.vue?vue&type=template&id=2ac48482&scoped=true&"
import script from "./vip-board.vue?vue&type=script&lang=ts&"
export * from "./vip-board.vue?vue&type=script&lang=ts&"
import style0 from "./vip-board.vue?vue&type=style&index=0&id=2ac48482&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac48482",
  null
  
)

export default component.exports